import { Button, ButtonColor, ButtonSize, ButtonTypes } from "@repo/ui";

import { useComponentContext } from "../../contexts/componentContext";
import style from "./style.module.scss";
import { Props } from "./types";

export default function DynamicButton(props: Props) {
	const { mappedComponent } = props;
	const { customFunctions } = useComponentContext();
	const { propertyName, label, component: baseComponent, extendedProperties, disabled, linkName } = mappedComponent;
	const { value, prefix } = baseComponent;
	const { inline, size } = extendedProperties;

	const buttonOptions = {
		color: ButtonColor[propertyName],
		size: ButtonSize[size],
		types: [ButtonTypes[prefix]],
	};

	async function onClick() {
		await customFunctions(value)();
	}

	const className = inline ? style.inlineButton : null;
	return (
		<Button className={className} disabled={disabled} onClick={onClick} id={linkName} {...buttonOptions}>
			{label}
		</Button>
	);
}
